<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      v-if="record && !lesson.status"
      class="body-1"
    >
      <v-card :loading="loading?'primary':null">
        <v-toolbar :color="lessonColor" flat>
          <v-toolbar-title>Запись</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <h2 class="body-1 font-weight-medium">
            {{ lesson.beginTime}}-{{ lesson.endTime}}, {{ lessonDate }}</h2>
          <h2 class="body-1">{{ className }}</h2>
          <div>{{ filialName }}</div>
          <div class="mt-4">Отменить запись на занятие?</div>
        </v-container>
        <v-card-actions class="align-center">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog=false">Нет</v-btn>
          <v-btn text color="accent" @click="cancelRecord">Да</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errorCancelRecord" top right color="error">
      Не удалось отменить записать на занятие</v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { getClassName, getClassColor } from '../../lib/classHelpers';
import Lesson from '../../api/Lesson';

export default {
  name: 'CancelRecordPopup',
  props: ['lesson', 'value'],
  data: () => ({
    errorCancelRecord: false,
    loading: false,
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    lessonDate() {
      return moment(this.lesson.date).format('DD.MM.YYYY');
    },
    lessonColor() {
      return getClassColor(this.lesson.classId);
    },
    className() {
      return getClassName(this.lesson.classId);
    },
    filialName() {
      const filial = this.filials.find(f => f.id === this.lesson.filialId);
      return filial ? filial.name : '';
    },
    teachers() {
      return this.managers
        .filter(m => this.lesson.teacherIds && this.lesson.teacherIds.includes(m.id))
        .map(m => m.name).join(', ');
    },
    roomName() {
      const room = this.rooms.find(r => r.id === this.lesson.roomId);
      return room ? room.name : '';
    },
    record() {
      return this.lesson.records && this.lesson.records.length > 0 ? this.lesson.records[0] : null;
    },
    canRecord() {
      const cl = this.classes.find(c => c.id === this.lesson.classId);
      return cl && cl.allowRecords
          && (this.lesson.freeRecords === null || this.lesson.freeRecords > 0);
    },
    classPayType() {
      const cl = this.classes.find(c => c.id === this.lesson.classId);
      return cl ? cl.payType : null;
    },
    ...mapGetters(['classes', 'courses', 'filials', 'rooms', 'managers', 'currentUser']),
  },
  methods: {
    async cancelRecord() {
      this.loading = true;
      try {
        if (this.record) {
          await Lesson.deleteRecord(this.record.id);
        }
        this.$emit('change');
      } catch (e) {
        this.errorCancelRecord = true;
      }
      this.loading = false;
      this.dialog = false;
    },
  },
};
</script>

<style scoped>

</style>
